import { Box, Stack } from "@mui/material"
import { Suspense, createContext, useCallback, useRef, useState } from "react"
import { Outlet } from "react-router"

import LoadingScreen from "@sap/components/loading-screen"

import Footer from "./Footer"
import Header from "./Header"
import Navbar from "./NavBar"
import SearchInput from "./SearchBox"
import Sticky from "./Sticky"
import Topbar from "./Topbar"

// eslint-disable-next-line react-refresh/only-export-components
export const MainLayoutContext = createContext<{
  showMobileSearch: boolean
  setShowMobileSearch: (fixed: boolean) => void
  inputRef: React.RefObject<HTMLInputElement>
}>({
  showMobileSearch: false,
  setShowMobileSearch: () => {},
  inputRef: { current: null },
})

const MainLayout = () => {
  const [showMobileSearch, setShowMobileSearch] = useState(false)
  const [isFixed, setIsFixed] = useState(false)
  const inputRef = useRef<HTMLInputElement>(null)
  const toggleIsFixed = useCallback((fixed: boolean) => setIsFixed(fixed), [])

  //console.log(inputRef.current?.focus())

  const isProduction = import.meta.env.VITE_ENVIRONMENT === "production"
  return (
    <MainLayoutContext.Provider
      value={{
        showMobileSearch,
        setShowMobileSearch,
        inputRef,
      }}
    >
      <Stack sx={{ height: "inherit" }}>
        {/* TOPBAR */}
        {!isProduction && <Topbar />}
        {/* <Topbar /> */}

        {/* HEADER */}
        <Sticky fixedOn={0} onSticky={toggleIsFixed} scrollDistance={isProduction ? 0 : 64}>
          <Header isFixed={isFixed} searchInput={<SearchInput ref={inputRef} />} />
        </Sticky>

        <Box
          className="section-after-sticky"
          sx={{
            flexGrow: 1,
          }}
        >
          {/* NAVIGATION BAR  */}
          <Navbar />

          {/* BODY CONTENT */}
          <Suspense fallback={<LoadingScreen isDashboard />}>
            <Outlet />
          </Suspense>
        </Box>

        {/* SMALL DEVICE BOTTOM NAVIGATION */}
        {/* <MobileNavigationBar /> */}

        {/* FOOTER */}
        <Footer />
      </Stack>
    </MainLayoutContext.Provider>
  )
}
export default MainLayout
